import React from 'react';
import { useBrandConfig } from '../../hooks/useBrandConfig';
import './BrandLogo.css';

interface BrandLogoProps {
    eventBrand?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ eventBrand }) => {
    const brandConfig = useBrandConfig(eventBrand);

    if (!brandConfig || !brandConfig.logoUrl) {
        return null;
    }

    return (
        <img
            src={brandConfig.logoUrl}
            alt={`${brandConfig.brand_name} Logo`}
            className="brand-logo"
            loading="eager"
        />
    );
};

export default BrandLogo;
